<template>
  <v-btn icon @click="$emit('click')">
    <v-icon x-large>{{ mdiClose }}</v-icon>
  </v-btn>
</template>

<script lang="ts">
import { defineComponent } from "vue"
import { mdiClose } from "@mdi/js"
export default defineComponent({
  name: "CloseButton",
  setup() {
    return {
      mdiClose,
    }
  },
})
</script>
